import * as angular from "angular";
import * as _ from "lodash";
import * as moment from "moment";
import {PlanningDraftType} from "../types/planning-draft.type";
import {IIntervalService} from "angular";
import {PlanProjectEntity} from "../models/plan-project-entity.model";
import {PlanningDraftsService} from "./planning-drafts-service.service";
import {BatchRequestsService} from "../../batch/services/batch-requests.service";
import {SiteContextService} from "../../commons/services/site-context.service";
import {PlanningAlertsService} from "./planning-alerts.service";
import {AccountModel} from "../../account/angular/models/account.model";
import {SiteFiltersType} from "../../commons/types/site-filters.type";
import {PanelService} from "../../commons/angular/services/panel.service";
import {PlanningTemplateDefaultDraftService} from "./planning-template-default-draft.service";
import {PlanningRequestsService} from "./planning-requests.service";
import {Service} from "../../deliveries/models/service.model";
import {ServiceType} from "../../deliveries/types/service.type";
import {ResourceSkill} from "../../agents/types/resourceSkill.type";
import {DraftAccountData} from "../models/draft-account-data.model";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";
import {JobSuggestion, JobSuggestionDecision} from "../models/job-suggestion.model";
import {SplitService} from "../../commons/services/split-service.service";
import {PlanningClusteringAreasRequestsService} from "./planning-clustering-areas-requests.service";
import {ClusteringMode} from "../types/clustering-mode.type";
import {ConfirmDialogService} from "../../commons/services/confirm-dialog.service";
import {DraftJobChangesSyncState} from "../types/draft-job-changes-sync-state.enum";
import {PollingIntervalService} from "../../commons/services/polling-interval.service";

export class PlanningDialogService {

  private _isDraftOptimizingLoaderShowing: boolean = false;
  private _isProjectOptimizingLoaderShowing: boolean = false;

  constructor(private $mdDialog, private planningConstants, private planningDraftsService: PlanningDraftsService,
              private $interval: IIntervalService, private siteContextService: SiteContextService, private panelService: PanelService,
              private planningTemplateDefaultDraftService: PlanningTemplateDefaultDraftService, private $timeout,
              private bringozToastService: BringozToastService, private $translate, private splitService: SplitService,
              private planningClusteringAreasRequestsService: PlanningClusteringAreasRequestsService) {
  }

  createProject(event?, isShowPlanningTemplatesSelect?, from?, to?, isCreateWithPreSelectedSteps?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-project-dialog.html').default,

      controller: function ($scope) {
        $scope.isShowPlanningTemplatesSelect = isShowPlanningTemplatesSelect;

        $scope.today = new Date();
        $scope.project = {
          name: undefined,
          from: from || moment().startOf('day').valueOf(),
          to: to || moment().endOf('day').set({'minute': 30, 'second': 0, 'millisecond': 0}).valueOf(),
          branchIds: []
        } as PlanProjectEntity;


        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        //        Public methods
        // ******************************

        $scope.onTemplateSelect = (template) => {
          $scope.project.projectTemplateId = _.get(template, 'id');
          $scope.project.branchIds = _.get(template, 'branchIds', []);
          if (!!template?.draftTemplateId) {
            $scope.project.draftTemplateId = template.draftTemplateId;
            $scope.project.useDraftTemplateSettings = template.useDraftTemplateSettings;
            $scope.isDisableDraftTemplateSettings = true;
          } else {
            $scope.project.draftTemplateId = undefined;
            $scope.project.useDraftTemplateSettings = undefined;
            $scope.isDisableDraftTemplateSettings = false;
          }
          if (template?.fromTime) {
            const [hour, minute] = template.fromTime.split(':').map(Number);
            $scope.project.from = moment($scope.project.from).set({hour, minute, second: 0, millisecond: 0}).valueOf();
          }
          if (template?.toTime) {
            const [hour, minute] = template.toTime.split(':').map(Number);
            $scope.project.to = moment($scope.project.to).set({hour, minute, second: 0, millisecond: 0}).valueOf();
          }
        }
        $scope.onFromDateChange = (selectedDate) => {
          $scope.project.from = moment(selectedDate).startOf('day').valueOf();

          if ($scope.project.from >= $scope.project.to) {
            $scope.project.to = moment(selectedDate).endOf('day').set({
              'minute': 30,
              'second': 0,
              'millisecond': 0
            }).valueOf();
          }
        }
        $scope.onFromTimeChange = (time) => {
          $scope.project.from = time;
        }
        $scope.onToDateChange = (date) => {
          $scope.project.to = moment(date).endOf('day').set({'minute': 30, 'second': 0, 'millisecond': 0}).valueOf();
        }
        $scope.onToTimeChange = (time) => {
          $scope.project.to = time;
        }

        $scope.onBranchesSelect = (branchIds) => {
          $scope.project.branchIds = branchIds;
        }
        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted();
            if (form.$valid) {
              self.$mdDialog.hide($scope.project);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  createOrSelectProject(event, isShowPlanningTemplatesSelect: boolean, from: number, to: number, isCreateWithPreSelectedSteps: boolean) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-or-select-project-dialog.html').default,
      controller: function ($scope) {
        $scope.isCreateWithPreSelectedSteps = isCreateWithPreSelectedSteps
        $scope.isShowPlanningTemplatesSelect = isShowPlanningTemplatesSelect;
        $scope.action = 'Create';
        $scope.projectId = undefined;
        $scope.createOrAddTooExistingProject = 'CREATE_NEW'

        $scope.today = new Date();


        $scope.createEmptyProject = () => {
          $scope.project = {
            name: undefined,
            from: from || moment().startOf('day').valueOf(),
            to: to || moment().endOf('day').set({'minute': 30, 'second': 0, 'millisecond': 0}).valueOf(),
            branchIds: []
          } as PlanProjectEntity;
        }

        $scope.createEmptyProject();

        $scope.onChangeScenario = (createOrAddTooExistingProject) => {
          $scope.createOrAddTooExistingProject = createOrAddTooExistingProject;

          if ($scope.createOrAddTooExistingProject === 'CREATE_NEW') {
            $scope.projectId = undefined;
            $scope.createEmptyProject();
          } else {
            $scope.project = undefined
            $scope.projectId = undefined;
          }
        }

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        //        Public methods
        // ******************************

        $scope.onProjectSelected = (projectId) => {
          $scope.projectId = projectId;
        }

        $scope.onTemplateSelect = (template) => {
          $scope.project.projectTemplateId = _.get(template, 'id');
          $scope.project.branchIds = _.get(template, 'branchIds', []);
          if (!!template?.draftTemplateId) {
            $scope.project.draftTemplateId = template.draftTemplateId;
            $scope.project.useDraftTemplateSettings = template.useDraftTemplateSettings;
            $scope.isDisableDraftTemplateSettings = true;
          } else {
            $scope.project.draftTemplateId = undefined;
            $scope.project.useDraftTemplateSettings = undefined;
            $scope.isDisableDraftTemplateSettings = false;
          }
          if (template?.fromTime) {
            const [hour, minute] = template.fromTime.split(':').map(Number);
            $scope.project.from = moment($scope.project.from).set({hour, minute, second: 0, millisecond: 0}).valueOf();
          }
          if (template?.toTime) {
            const [hour, minute] = template.toTime.split(':').map(Number);
            $scope.project.to = moment($scope.project.to).set({hour, minute, second: 0, millisecond: 0}).valueOf();
          }
        }
        $scope.onFromDateChange = (selectedDate) => {
          $scope.project.from = moment(selectedDate).startOf('day').valueOf();

          if ($scope.project.from >= $scope.project.to) {
            $scope.project.to = moment(selectedDate).endOf('day').set({
              'minute': 30,
              'second': 0,
              'millisecond': 0
            }).valueOf();
          }
        }
        $scope.onFromTimeChange = (time) => {
          $scope.project.from = time;
        }
        $scope.onToDateChange = (date) => {
          $scope.project.to = moment(date).endOf('day').set({'minute': 30, 'second': 0, 'millisecond': 0}).valueOf();
        }
        $scope.onToTimeChange = (time) => {
          $scope.project.to = time;
        }

        $scope.onBranchesSelect = (branchIds) => {
          $scope.project.branchIds = branchIds;
        }
        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted();
            if (form.$valid) {
              self.$mdDialog.hide({project: $scope.project as PlanProjectEntity, projectId: $scope.projectId});
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }


  createTemplate(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      templateUrl: 'app/modules/planning/views/dialogs/create-template-dialog.html',
      controller: function ($scope) {

        $scope.template = {
          name: undefined,
          branchIds: []
        };

        $scope.onBranchesSelect = (branchIds) => {
          $scope.template.branchIds = branchIds;
        }
        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.template);
            }
          }
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  createDraft(project, depots, selectedJobs, draftTemplate, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/planning-settings-dialog.html').default,
      controller: function ($scope, $filter) {

        $scope.header = 'Create New Draft';
        $scope.action = 'Create';
        $scope.PlanningDraftType = PlanningDraftType;

        $scope.project = project;
        if (!$scope.project.clusteringAreaIds) {
          $scope.project.clusteringAreaIds = [];
        }
        $scope.settings = angular.copy(project.settings);
        $scope.settingsCopy = angular.copy(project.settings);
        $scope.draftTemplate = angular.copy(draftTemplate);
        $scope.useDraftTemplateSettings = project.useDraftTemplateSettings;

        $scope.isShowDeliveryAddressSelect = selectedJobs.find((job) => {
          return job.jobType === ServiceType.Delivery;
        });
        $scope.isShowFieldServiceAddressSelect = selectedJobs.find((job) => {
          return job.jobType === ServiceType.Operation;
        });

        const draftTranslation = $filter('translate')('Draft');
        $scope.draftName = project.draftsIds?.length ? `${draftTranslation} ${project.draftsIds.length + 1}` : `${draftTranslation} 1`;

        if (self.siteContextService.getSiteInfo().defaultPlanningDraftType === PlanningDraftType.DISTRIBUTION) {
          $scope.settings.distribution = true;
        }

        $scope.depotOptions = angular.copy(depots);
        $scope.isFirstSection = true;
        $scope.selectedJobs = selectedJobs;

        $scope.options = {
          trafficStates: self.planningConstants.trafficStates,
          optimizationTypes: self.planningConstants.optimizationTypes,
          roadRestrictions: self.planningConstants.roadRestrictions,
          locationTypes: self.planningConstants.locationTypes
        };

        $scope.isOptimizedDraft = true;
        $scope.useLayeredDraftSettings = self.splitService.getSupportLayeredPlanning();
        $scope.draft = {
          name: $scope.draftName,
          settings: angular.copy($scope.settings),
          optimizationSteps: angular.copy(project.optimizationSteps) || [],
          draftTemplateId: $scope.draftTemplate?.id,
          useDraftTemplateSettings: $scope.useDraftTemplateSettings
        };
        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        //        Public methods
        // ******************************

        $scope.onChangeTemplateDefaultDraft = (id, draftTemplate) => {
          $scope.draftTemplate = draftTemplate;

          if (!!draftTemplate?.settings) {
            $scope.settings = angular.copy(draftTemplate.settings);
            $scope.useDraftTemplateSettings = true;
          } else {
            $scope.settings = angular.copy($scope.settingsCopy);
            $scope.useDraftTemplateSettings = false;
          }

          if ($scope.draft) {
            $scope.draft.settings = angular.copy($scope.settings);
            $scope.draft.draftTemplateId = draftTemplate?.id;
            $scope.draft.useDraftTemplateSettings = $scope.useDraftTemplateSettings;
          }
        }

        $scope.onToggleUseDraftTemplateSettings = () => {
          $scope.useDraftTemplateSettings = !$scope.useDraftTemplateSettings;

          if ($scope.useDraftTemplateSettings) {
            $scope.settings = angular.copy($scope.draftTemplate.settings);
          } else {
            $scope.settings = angular.copy($scope.settingsCopy);
          }

          if ($scope.draft) {
            $scope.draft.settings = angular.copy($scope.settings);
            $scope.draft.useDraftTemplateSettings = $scope.useDraftTemplateSettings;
          }
        }

        $scope.onDraftChange = (draft) => {
          $scope.draft = draft;
          $scope.draftName = draft.name;
        }

        $scope.onChangeDraftTemplate = (draft, draftTemplate) => {
          $scope.draft = angular.copy(draft);
          $scope.draftTemplate = angular.copy(draftTemplate);
          $scope.draftName = draft.name;
          $scope.useDraftTemplateSettings = draft.useDraftTemplateSettings;
        }

        $scope.continue = (form) => {
          form.form.FirstSection.$setSubmitted();
          if (form.form.FirstSection.$valid) {
            if ($scope.draft) {
              $scope.draft.name = $scope.draftName;
              $scope.draft.settings = angular.copy($scope.settings);
              $scope.draft.draftTemplateId = $scope.draftTemplate?.id;
              $scope.draft.useDraftTemplateSettings = $scope.useDraftTemplateSettings;
            }
            $scope.isFirstSection = false;
          }
        }

        $scope.onBack = () => {
          if ($scope.useLayeredDraftSettings && $scope.draft) {
            $scope.settings = angular.copy($scope.draft.settings);
            $scope.settingsCopy = angular.copy($scope.draft.settings);
            $scope.draftName = $scope.draft.name;
          }
          $scope.isFirstSection = true;
        }

        $scope.onOptimizedDraftChanged = () => {
          $scope.isOptimizedDraft = !$scope.isOptimizedDraft;
        }

        $scope.onSettingsChange = (settings) => {
          $scope.settings = settings;
          $scope.settingsCopy = angular.copy(settings);
          if ($scope.draft) {
            $scope.draft.settings = angular.copy(settings);
          }
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide({
                settings: ($scope.isFirstSection || !$scope.useLayeredDraftSettings) ? $scope.settings : $scope.draft.settings,
                optimizationSteps: $scope.useLayeredDraftSettings ? ($scope.draft.optimizationSteps || []) : [],
                draftName: $scope.draftName,
                draftTemplateId: $scope.draftTemplate?.id,
                useDraftTemplateSettings: $scope.useDraftTemplateSettings,
                isOptimizedDraft: $scope.isOptimizedDraft
              });
            }
          }
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }


  compareDrafts(drafts, projectSelectedDraftId?, settings?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/compare-drafts-dialog.html').default,
      controller: function ($scope) {

        $scope.drafts = angular.copy(drafts);
        $scope.settings = settings;
        $scope.projectSelectedDraftId = angular.copy(projectSelectedDraftId);
        $scope.selectedDraftsMap = _.mapValues(_.keyBy(drafts, 'id'), (value) => {
          return {
            enabled: true,
            data: value
          }
        })

        $scope.cancel = self.$mdDialog.cancel;
        $scope.onToggleCheckDraft = (draft) => {
          $scope.selectedDraftsMap[draft.id].enabled = !$scope.selectedDraftsMap[draft.id].enabled
        }

        $scope.isDraftChecked = (draft) => {
          return _.includes($scope.selectedDraftIds, draft.id);
        }

        $scope.onSetSelectedDraftToProject = (draftId) => {
          self.$mdDialog.hide(draftId);
        }


      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }


  updateProjectDetails(project, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/project-details-dialog.html').default,
      controller: function ($scope) {

        $scope.project = angular.copy(project);

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.project);
            }

          }
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }


  createProjectByServices(services: Service[], isFirstSection?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/planning-settings-dialog.html').default,
      controller: function ($scope) {

        $scope.depotIdsOptions = _.uniq(_.compact(_.flatMap(services, (s: Service) => {
          return s.depotIds;
        })))
        // $scope.isShowDeliveryAddressSelect = services.find((s: Service) => {
        //   return s.serviceType === ServiceType.Delivery;
        // });
        // $scope.isShowFieldServiceAddressSelect = services.find((s: Service) => {
        //   return s.serviceType === ServiceType.Operation;
        // });

        $scope.settings = {};

        // if (!!$scope.isShowDeliveryAddressSelect) {
        //   $scope.settings.driverLocationSettings = {
        //     departurePointType: $scope.depotIdsOptions.length ? 'DEPOT' : 'CUSTOM',
        //     destinationPointType: $scope.depotIdsOptions.length ? 'DEPOT' : 'CUSTOM'
        //   }
        // }
        //
        // if (!!$scope.isShowFieldServiceAddressSelect) {
        //   $scope.settings.serviceLocationSettings = {
        //     destinationPointType: $scope.depotIdsOptions.length ? 'DEPOT' : 'CUSTOM'
        //   }
        // }


        $scope.header = 'Settings';
        $scope.action = 'Submit';
        $scope.isFirstSection = isFirstSection;

        $scope.options = {
          trafficStates: self.planningConstants.trafficStates,
          optimizationTypes: self.planningConstants.optimizationTypes,
          roadRestrictions: self.planningConstants.roadRestrictions,
          locationTypes: self.planningConstants.locationTypes
        };

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        //        Public methods
        // ******************************

        $scope.continue = (form) => {
          form.form.FirstSection.$setSubmitted();
          if (form.form.FirstSection.$valid) {
            $scope.isFirstSection = false;
          }
        }

        $scope.onBack = () => {
          $scope.isFirstSection = true;
        }

        $scope.onSettingsChange = (settings) => {
          $scope.settings = settings;
        }


        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.settings);
            }
          }
        }

        ///////////////////////////////////////////////////////////////


      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editProjectSettings(project, draftTemplate, depots?, selectedJobs?, event?, onClusteringAreasUpdated?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/planning-project-settings-dialog.html').default,
      controller: function ($scope) {

        $scope.project = angular.copy(project);
        $scope.draftTemplate = draftTemplate;
        $scope.depots = depots ? angular.copy(depots) : [];
        $scope.selectedJobs = selectedJobs ? angular.copy(selectedJobs) : [];
        $scope.settings = angular.copy(project.settings || {});
        $scope.settingsCopy = angular.copy(project.settings || {});
        $scope.project.settings = angular.copy($scope.settings);
        $scope.useDraftTemplateSettings = project.useDraftTemplateSettings;
        $scope.useLayeredProjectSettings = self.splitService.getSupportLayeredPlanning();

        if (!$scope.project.clusteringAreaIds) {
          $scope.project.clusteringAreaIds = [];
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onProjectChange = (project) => {
          $scope.project = project;
        }

        $scope.onChangeDraftTemplate = (project, draftTemplate) => {
          $scope.project = angular.copy(project);
          $scope.draftTemplate = angular.copy(draftTemplate);
        }

        $scope.onChangeTemplateDefaultDraft = (id, draftTemplate) => {
          $scope.draftTemplate = draftTemplate;

          if (!draftTemplate) {
            $scope.project.draftTemplateId = undefined;
            $scope.useDraftTemplateSettings = false;
            $scope.settings = angular.copy($scope.settingsCopy);
          } else {
            $scope.project.draftTemplateId = draftTemplate.id;
            if (!!draftTemplate.settings) {
              $scope.settings = angular.copy(draftTemplate.settings);
              $scope.useDraftTemplateSettings = true;
            } else {
              $scope.settings = angular.copy($scope.settingsCopy);
              $scope.useDraftTemplateSettings = false;
            }
          }

          $scope.project.useDraftTemplateSettings = $scope.useDraftTemplateSettings;
          $scope.project.settings = angular.copy($scope.settings);
        }

        $scope.onToggleUseDraftTemplateSettings = () => {
          if (!$scope.draftTemplate?.settings) {
            return;
          }

          $scope.useDraftTemplateSettings = !$scope.useDraftTemplateSettings;

          if ($scope.useDraftTemplateSettings) {
            $scope.settings = angular.copy($scope.draftTemplate.settings);
          } else {
            $scope.settings = angular.copy($scope.settingsCopy);
          }

          $scope.project.useDraftTemplateSettings = $scope.useDraftTemplateSettings;
          $scope.project.settings = angular.copy($scope.settings);
        }

        $scope.onSettingsChange = (settings) => {
          $scope.settings = settings;
          $scope.settingsCopy = angular.copy(settings);
          $scope.project.settings = angular.copy(settings);
        }

        $scope.onClusteringAreasUpdated = (clusteringAreas) => {
          if (_.isFunction(onClusteringAreasUpdated)) {
            onClusteringAreasUpdated(clusteringAreas);
          }
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              const projectCopy = angular.copy($scope.project);

              if (!$scope.useLayeredProjectSettings) {
                projectCopy.settings = angular.copy($scope.settings);
                projectCopy.draftTemplateId = $scope.project.draftTemplateId;
                projectCopy.useDraftTemplateSettings = $scope.useDraftTemplateSettings;
              }

              self.$mdDialog.hide({project: projectCopy});
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }


  editDraftSettings(project, draft, draftTemplate, depots?, event?, onClusteringAreasUpdated?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/planning-draft-settings-dialog.html').default,
      controller: function ($scope) {

        $scope.project = project;
        $scope.draft = angular.copy(draft);
        $scope.draftTemplate = draftTemplate;
        $scope.depots = depots ? angular.copy(depots) : [];

        if (!$scope.draft.clusteringAreaIds) {
          $scope.draft.clusteringAreaIds = [];
        }

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        //        Public methods
        // ******************************

        $scope.onDraftChange = (draft) => {
          $scope.draft = draft;
        }

        $scope.onChangeDraftTemplate = (draft, draftTemplate) => {
          $scope.draft = angular.copy(draft);
          $scope.draftTemplate = angular.copy(draftTemplate);
        }

        $scope.onClusteringAreasUpdated = (clusteringAreas) => {
          if (_.isFunction(onClusteringAreasUpdated)) {
            onClusteringAreasUpdated(clusteringAreas);
          }
        }


        $scope.submit = (form, doReoptimize?) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              const payload = {
                draft: $scope.draft,
                doReoptimize: doReoptimize
              }
              self.$mdDialog.hide(payload);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }


  editClusteringArea(clusteringArea, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-clustering-area-dialog.html').default,
      controller: function ($scope) {

        $scope.clusteringArea = angular.copy(clusteringArea);

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (area) => {
          self.$mdDialog.hide(area);
        };

      },
      targetEvent: event,
      clickOutsideToClose: false
    });
  }

  addJob(event, project) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-job-dialog.html').default,
      controller: function ($scope) {

        $scope.header = 'Add A Stop';
        $scope.action = 'Add';

        $scope.projectFrom = new Date(project.from);
        $scope.projectTo = new Date(project.to);

        $scope.branchIds = project.branchIds || [];
        $scope.depotOptions = project.depots || [];

        $scope.job = {
          accountId: undefined,
          depotId: undefined,
          jobType: 'Delivery', // TODO: NEED TO CHANGE!
          source: 'MANUAL',
          stops: [],
          priority: 2,
          packages: [
            {
              count: 1,
              size: 'NoPackage',
              labels: []
            }
          ],
        };
        $scope.stop = {
          stopType: 'Dropoff',
          contact: {
            name: undefined,
            phone: undefined
          },
          sla: undefined,
          serviceTime: undefined,
          address: {},
          notBefore: undefined,
          notAfter: undefined
        };
        $scope.sla = new Date(project.to);
        $scope.timeConfig = {
          date: moment($scope.sla).valueOf(),
          min: moment($scope.sla).startOf('day').valueOf(),
          max: moment($scope.sla).endOf('day').valueOf()
        };

        $scope.notBefore = undefined;
        $scope.notAfter = undefined;

        $scope.timeWindowTimeConfig = {
          notBefore: {
            date: undefined,
            min: undefined,
            max: undefined
          },
          notAfter: {
            date: undefined,
            min: undefined,
            max: undefined
          }
        };

        $scope.packageList = [];

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        //        Public methods
        // ******************************


        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              if ($scope.notBefore) {
                $scope.stop.notBefore = moment($scope.notBefore).valueOf();
              }

              if ($scope.notAfter) {
                $scope.stop.notAfter = moment($scope.notAfter).valueOf();
              }

              $scope.stop.sla = moment($scope.sla).valueOf();
              $scope.job.stops = [$scope.stop];

              //TODO REMOVE!!!
              _.forEach($scope.job.packages, (p) => {
                p.type = p.size;
                if (p.dimensions && p.dimensions.width) {
                  p.volume = p.dimensions.width;
                }
              });

              self.$mdDialog.hide($scope.job);
            }

          }
        }

        $scope.onAddressChange = (address) => {
          $scope.stop.address = address;
        }
        $scope.onContactPhoneChange = (phone) => {
          $scope.stop.contact.phone = phone;
        }
        $scope.onDepotSelect = (depotId) => {
          $scope.job.depotId = depotId;
        }
        $scope.onAccountSelect = (account) => {
          $scope.job.accountId = _.get(account, 'id', undefined);
        }
        $scope.onSLAChange = (date) => {
          $scope.sla = date;
          $scope.timeConfig = {
            date: moment(date).valueOf(),
            min: moment(date).startOf('day').valueOf(),
            max: moment(date).endOf('day').valueOf()
          }
        }
        $scope.onTimeChanged = (timestamp) => {
          $scope.sla = new Date(timestamp);
        }

        $scope.onPriorityChange = (compositePriority) => {
          $scope.job.compositePriority = compositePriority;
        }

        $scope.onPackageChange = (packageItem, index) => {
          _.set(packageItem, 'size', packageItem.type);
          _.set(packageItem, 'type', packageItem.type);

          const itemsCopy = angular.copy($scope.job.packages);
          itemsCopy[index] = packageItem;
          $scope.job.packages = itemsCopy;
        }

        // Time Window
        $scope.onTimeWindowNotBeforeChanged = (notBefore) => {
          $scope.notBefore = notBefore;
          $scope.timeWindowTimeConfig.notBefore = {
            date: moment(notBefore).valueOf(),
            min: moment(project.from).startOf('day').valueOf(),
            max: moment(project.to).endOf('day').valueOf()
          }
        }
        $scope.onTimeWindowNotAfterChanged = (notAfter) => {
          $scope.notAfter = notAfter;
          $scope.timeWindowTimeConfig.notAfter = {
            date: moment(notAfter).valueOf(),
            min: moment(project.from).startOf('day').valueOf(),
            max: moment(project.to).endOf('day').valueOf()
          }
        }
        $scope.onTimeWindowNotBeforeTimeChanged = (timestamp) => {
          $scope.notBefore = new Date(timestamp);
        }
        $scope.onTimeWindowNotAfterTimeChanged = (timestamp) => {
          $scope.notAfter = new Date(timestamp);
        }
        $scope.onToggleEnableTimeWindows = (isEnabled, type) => {
          if (type === 'notBefore') {
            if (isEnabled) {
              $scope.onTimeWindowNotBeforeChanged(new Date(project.from));
            } else {
              $scope.notBefore = undefined;
              $scope.timeWindowTimeConfig.notBefore = {
                date: undefined,
                min: undefined,
                max: undefined
              };
            }
          } else {
            if (isEnabled) {
              $scope.onTimeWindowNotAfterChanged(new Date(project.to))
            } else {
              $scope.notAfter = undefined;
              $scope.timeWindowTimeConfig.notAfter = {
                date: undefined,
                min: undefined,
                max: undefined
              };
            }
          }
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  // editJob(job, project, event) {
  //   return this.$mdDialog.show({
  //     parent: angular.element(document.body),
  //     template: require('./../views/dialogs/add-job-dialog.html').default,
  //     controller: ($scope) => {
  //
  //       $scope.header = 'Edit Stop';
  //       $scope.action = 'Update';
  //
  //       $scope.projectFrom = new Date(project.from);
  //       $scope.projectTo = new Date(project.to);
  //
  //       $scope.depotOptions = project.depots || [];
  //
  //       $scope.job = angular.copy(job);
  //       $scope.stop = angular.copy(job.stops[0]);
  //       $scope.sla = moment($scope.stop.sla).toDate();
  //
  //       $scope.timeConfig = {
  //         date: moment($scope.sla).valueOf(),
  //         min: moment($scope.sla).startOf('day').valueOf(),
  //         max: moment($scope.sla).endOf('day').valueOf()
  //       };
  //
  //       $scope.timeWindowTimeConfig = {
  //         notBefore: {
  //           date: undefined,
  //           min: undefined,
  //           max: undefined
  //         },
  //         notAfter: {
  //           date: undefined,
  //           min: undefined,
  //           max: undefined
  //         }
  //       };
  //
  //       if ($scope.stop.notBefore) {
  //         $scope.enableNotBefore = true;
  //         $scope.onTimeWindowNotBeforeChanged(new Date($scope.stop.notBefore));
  //       }
  //
  //       if ($scope.stop.notAfter) {
  //         $scope.enableNotAfter = true;
  //         $scope.onTimeWindowNotAfterChanged(new Date($scope.stop.notAfter));
  //       }
  //
  //       _.forEach($scope.job.packages, function (p) {
  //         if (p.volume) {
  //           p.dimensions = {
  //             width: p.volume,
  //             height: 1,
  //             length: 1
  //           }
  //         }
  //       });
  //
  //       $scope.cancel = this.$mdDialog.cancel;
  //       $scope.submit = (form) => {
  //         if (form) {
  //           form.$setSubmitted(true);
  //
  //           if (form.$valid) {
  //
  //             //TODO REMOVE!!!
  //             _.forEach($scope.job.packages, function (p) {
  //               p.type = p.size;
  //               if (p.dimensions && p.dimensions.width) {
  //                 p.volume = p.dimensions.width;
  //               }
  //             });
  //
  //             $scope.stop.notBefore = $scope.notBefore ? moment($scope.notBefore).valueOf() : undefined;
  //             $scope.stop.notAfter = $scope.notAfter ? moment($scope.notAfter).valueOf() : undefined;
  //
  //             $scope.stop.sla = moment($scope.sla).valueOf();
  //             $scope.job.stops = [$scope.stop];
  //
  //             this.$mdDialog.hide($scope.job);
  //           }
  //
  //         }
  //       }
  //
  //       $scope.onAddressChange = (address) => {
  //         $scope.stop.address = address;
  //       }
  //       $scope.onContactPhoneChange = (phone) => {
  //         $scope.stop.contact.phone = phone;
  //       }
  //       $scope.onDepotSelect = (depot) => {
  //         $scope.job.depot = depot.id;
  //       }
  //       $scope.onAccountSelect = (account) => {
  //         $scope.job.accountId = _.get(account, 'id', undefined);
  //       }
  //       $scope.onSLAChange = (date) => {
  //         $scope.sla = date;
  //         $scope.timeConfig = {
  //           date: moment(date).valueOf(),
  //           min: moment(date).startOf('day').valueOf(),
  //           max: moment(date).endOf('day').valueOf()
  //         }
  //       }
  //       $scope.onTimeChanged = (date) => {
  //         $scope.sla = new Date(date);
  //       }
  //       $scope.onPriorityChange = (compositePriority) => {
  //         $scope.job.compositePriority = compositePriority;
  //       }
  //
  //       // Time Window
  //       $scope.onTimeWindowNotBeforeChanged = (notBefore) => {
  //         $scope.notBefore = notBefore;
  //         $scope.timeWindowTimeConfig.notBefore = {
  //           date: moment(notBefore).valueOf(),
  //           min: moment(project.from).startOf('day').valueOf(),
  //           max: moment(project.to).endOf('day').valueOf()
  //         }
  //       }
  //       $scope.onTimeWindowNotAfterChanged = (notAfter) => {
  //         $scope.notAfter = notAfter;
  //         $scope.timeWindowTimeConfig.notAfter = {
  //           date: moment(notAfter).valueOf(),
  //           min: moment(project.from).startOf('day').valueOf(),
  //           max: moment(project.to).endOf('day').valueOf()
  //         }
  //       }
  //       $scope.onTimeWindowNotBeforeTimeChanged = (timestamp) => {
  //         $scope.notBefore = new Date(timestamp);
  //       }
  //       $scope.onTimeWindowNotAfterTimeChanged = (timestamp) => {
  //         $scope.notAfter = new Date(timestamp);
  //       }
  //       $scope.onToggleEnableTimeWindows = (isEnabled, type) => {
  //         if (type === 'notBefore') {
  //           if (isEnabled) {
  //             $scope.onTimeWindowNotBeforeChanged(new Date(project.from));
  //           } else {
  //             $scope.notBefore = undefined;
  //             $scope.timeWindowTimeConfig.notBefore = {
  //               date: undefined,
  //               min: undefined,
  //               max: undefined
  //             };
  //           }
  //         } else {
  //           if (isEnabled) {
  //             $scope.onTimeWindowNotAfterChanged(new Date(project.to))
  //           } else {
  //             $scope.notAfter = undefined;
  //             $scope.timeWindowTimeConfig.notAfter = {
  //               date: undefined,
  //               min: undefined,
  //               max: undefined
  //             };
  //           }
  //         }
  //       }
  //
  //
  //     },
  //     targetEvent: event,
  //     clickOutsideToClose: true
  //   })
  // }


  addOrders(event, project, template?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-orders-dialog.html').default,
      controller: function (splitService, $scope, planningRequestsService) {

        const templateFilter = template?.omsFilter;

        // Initialize default filters
        $scope.filters = {
          filterByCreatedAt: template?.omsImportByCreatedAt,
          from: templateFilter?.from || moment(project.from).startOf('day').valueOf(),
          to: templateFilter?.to || moment(project.to).endOf('day').valueOf(),
          dueFrom: templateFilter?.from || moment(project.from).startOf('day').valueOf(),
          dueTo: templateFilter?.to || moment(project.to).endOf('day').valueOf(),
          statuses: templateFilter?.statuses || [],
          branchIds: templateFilter?.branchIds || project.branchIds || [],
          accountIds: templateFilter?.accountIds || [],
          serviceAreaIds: templateFilter?.serviceAreaIds || [],
          pickupDepotIds: templateFilter?.pickupDepotIds || [],
          destinationDepotIds: templateFilter?.destinationDepotIds || [],
          routed: templateFilter?.routed,
          packed: templateFilter?.packed,
          attempts: templateFilter?.attempts,
          tags: templateFilter?.tags || [],
          excludedTags: templateFilter?.excludedTags || [],
          programTypes: templateFilter?.programTypes || [],
          schedulingRequired: templateFilter?.schedulingRequired,
          noFromLocation: templateFilter?.noFromLocation,
          obligateTimeWindow: templateFilter?.obligateTimeWindow
        }

        // ******************************
        //        Public methods
        // ******************************

        $scope.onChangeFilter = (filters) => {
          $scope.filters = filters;
        }


        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (form) => {
          form.$setSubmitted();

          if (form.$valid) {
            self.$mdDialog.hide($scope.filters);
          }
        }
      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  addServices(event, project, template?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-services-dialog.html').default,

      controller: function (splitService, $scope, planningRequestsService) {

        $scope.project = project;
        $scope.header = 'Import Services';

        const templateFilter = template?.dispatchFilter;

        // Initialize default filters
        $scope.filters = {
          dateFilterBy: templateFilter?.dateFilterBy || 'dueDate',
          from: templateFilter?.from || moment(project.from).startOf('day').valueOf(),
          to: templateFilter?.to || moment(project.to).endOf('day').valueOf(),
          dueFrom: templateFilter?.from || moment(project.from).startOf('day').valueOf(),
          dueTo: templateFilter?.to || moment(project.to).endOf('day').valueOf(),
          serviceAreaIds: templateFilter?.serviceAreaIds || [],
          depotIds: templateFilter?.depotIds || [],
          statuses: templateFilter?.statuses || [],
          accountIds: templateFilter?.accountIds || [],
          serviceTypes: templateFilter?.serviceTypes || [],
          tags: templateFilter?.tags || [],
          excludedTags: templateFilter?.excludedTags || [],
          programTypes: templateFilter?.programTypes || [],
          packageTypes: templateFilter?.packageTypes || [],
          routed: templateFilter?.routed,
          packed: templateFilter?.packed,
          pickupTimeFrom: undefined,
          pickupTimeTo: undefined,
          dropoffTimeFrom: undefined,
          dropoffTimeTo: undefined
        };

        // $scope.importAbortedServices = false;

        // ******************************
        //        Public methods
        // ******************************

        $scope.onChangeFilter = (filters) => {
          $scope.filters = filters;
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (form) => {
          form.$setSubmitted();

          if (form.$valid) {
            self.$mdDialog.hide($scope.filters);
          }
        }


      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  addAbortedServices(event, project) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-services-dialog.html').default,

      controller: function (splitService, $scope) {

        $scope.header = 'Import Aborted Services';
        $scope.isHideStatusSelect = true;

        $scope.filters = {
          dateFilterBy: 'dueDate',
          from: moment(project.from).startOf('day').valueOf(),
          to: moment(project.to).endOf('day').valueOf(),
          dueFrom: moment(project.from).startOf('day').valueOf(),
          dueTo: moment(project.to).endOf('day').valueOf(),
          serviceAreaIds: [],
          depotIds: [],
          statuses: [],
          accountIds: [],
          serviceTypes: [],
          tags: [],
          programTypes: [],
          packageTypes: [],
          routed: undefined,
          packed: undefined
        }

        $scope.importAbortedServices = false;

        // ******************************
        //        Public methods
        // ******************************

        $scope.onChangeFilter = (filters) => {
          $scope.filters = filters;
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (form) => {
          form.$setSubmitted();

          if (form.$valid) {
            self.$mdDialog.hide($scope.filters);
          }
        }


      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  addSteps(event, project, template?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-steps-dialog.html').default,

      controller: function (splitService, $scope, planningRequestsService) {

        const templateFilter = template?.fulfillmentFilter?.stepFilter;

        // Initialize default filters
        $scope.filters = {
          from: moment(templateFilter?.from).startOf('day').toDate(),
          to: moment(templateFilter?.to).endOf('day').toDate(),
          branchIds: templateFilter?.branchIds || project.branchIds || [],
          accountIds: templateFilter?.accountIds || [],
          serviceAreaIds: templateFilter?.serviceAreaIds || [],
          depotIds: templateFilter?.depotIds || [],
          serviceTypes: templateFilter?.types || [],
          agentIds: templateFilter?.agentIds || [],
          tags: templateFilter?.tags || [],
          excludedTags: templateFilter?.excludedTags || [],
          vehicleIds: templateFilter?.vehicleIds || [],
          displayStatuses: templateFilter?.displayStatuses || [],
          approvalStatuses: templateFilter?.approvalStatuses || [],
          programIds: templateFilter?.programTypes || [],
          packageIds: template?.fulfillmentFilter?.fulfillmentFilter?.packageTypes || [],
          schedulingRequired: templateFilter?.schedulingRequired,
          obligateTimeWindow: templateFilter?.obligateTimeWindow,
          inRoute: templateFilter?.routed,
          noFromLocation: templateFilter?.noFromLocation,
          noToLocation: templateFilter?.noToLocation,
          fulfillmentMileType: undefined,
          isReturnDelivery: templateFilter?.isReturn,
          filterByCreatedAt: templateFilter?.filterByCreatedAt !== undefined ? templateFilter?.filterByCreatedAt : splitService.getSiteFulfillmentSettings(splitService.getSiteId()).filterByCreatedAt
        }

        // Handle fulfillment mile type
        if (templateFilter?.firstMile) {
          $scope.filters.fulfillmentMileType = 'firstMile';
        } else if (templateFilter?.middleMile) {
          $scope.filters.fulfillmentMileType = 'middleMile';
        } else if (templateFilter?.lastMile) {
          $scope.filters.fulfillmentMileType = 'lastMile';
        }

        // ******************************
        //        Public methods
        // ******************************

        $scope.onChangeFilters = (filters) => {
          $scope.filters = filters;
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (form) => {
          form.$setSubmitted();

          if (form.$valid) {
            self.$mdDialog.hide($scope.filters);
          }
        }


      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  selectAllocationResources(from, to, projectId, branchIds, projectResourceIds, enabledExcludeModeFilters: {
    [key: string]: boolean
  }, isShowImportAllocationServiceTemplateOption, event, template?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/select-allocation-resources-dialog.html').default,
      controller: function ($scope, planningRequestsService, planningAlertsService: PlanningAlertsService, $mdDialog, $filter) {

        $scope.projectResourceIds = projectResourceIds;

        $scope.resources = [];
        $scope.agentSkills = [];
        $scope.selectedIds = [];
        $scope.loading = false;
        $scope.projectBranchIds = branchIds; //Should not be deselected
        $scope.filterOutWithoutAgent = true;
        $scope.filterOutNotAvailableVehicle = false;
        $scope.enabledExcludeModeFilters = enabledExcludeModeFilters;
        $scope.siteFilterTypes = SiteFiltersType;
        $scope.isShowImportAllocationServiceTemplateOption = isShowImportAllocationServiceTemplateOption;
        $scope.excludeAllocationsBeforeFromDate = false;

        $scope.queryParams = {
          importAllocationResourcesServiceTemplate: false
        }


        //filters
        $scope.queryString = undefined;
        $scope.branchIds = branchIds;
        $scope.agentIds = undefined;
        $scope.vehicleTypeIds = undefined; // type
        $scope.vehicleTypes = undefined // class
        $scope.resourceTags = template?.resourceTags?.length ? template.resourceTags : undefined;
        _initResources();

        $scope.onQueryChange = (queryString) => {
          $scope.queryString = queryString;
        }

        $scope.onVehicleSelect = (selectedIds) => {
          $scope.vehicleTypeIds = selectedIds;
          _initResources();
        }
        $scope.onBranchesSelect = (selectedIds) => {
          $scope.branchIds = selectedIds.length ? selectedIds : $scope.projectBranchIds;
          _initResources();
        }

        $scope.onAgentsSelect = (selectedIds) => {
          $scope.agentIds = selectedIds;
          _initResources();
        }

        $scope.onAgentSkillsSelect = (skills) => {
          $scope.agentSkills = skills;
          _initResources();
        }

        $scope.onResourceTagsSelect = (tags) => {
          $scope.resourceTags = tags;
          _initResources();
        }

        $scope.onAgentTagsSelect = (tags, isExcludeMode) => {
          if (isExcludeMode) {
            $scope.agentTags = undefined;
            $scope.excludedAgentTags = tags;
          } else {
            $scope.agentTags = tags;
            $scope.excludedAgentTags = undefined;
          }
          _initResources();
        }

        $scope.onChangeVehicleTypesChanged = (selectedIds) => {
          $scope.vehicleTypes = selectedIds
          _initResources();
        }

        $scope.onToggleExcludeUnavailableAgents = () => {
          _initResources();
        }

        $scope.onToggleExcludeAllocationsBeforeFromDate = () => {
          _initResources();
        }

        $scope.onToggleFilterOutNotAvailableVehicle = () => {
          _initResources();
        }

        $scope.onResourceToggle = (resource) => {
          const isInclude = _.includes($scope.selectedIds, resource.id)

          if (isInclude) {
            $scope.selectedIds = _.filter($scope.selectedIds, (i) => {
              return i !== resource.id;
            })
          } else {
            $scope.selectedIds.push(resource.id);
          }
        }

        $scope.getFilteredResources = () => {
          if (!$scope.queryString || $scope.queryString.trim() === '') {
            return $scope.resources;
          }

          return $filter('filter')($scope.resources, $scope.queryString);
        };

        $scope.onResourceToggleAll = () => {
          const filteredResources = $scope.getFilteredResources();
          const filteredIds = _.map(filteredResources, 'id');

          const allFilteredSelected = filteredIds.length > 0 &&
            _.every(filteredIds, id => _.includes($scope.selectedIds, id));

          if (allFilteredSelected) {
            $scope.selectedIds = _.filter($scope.selectedIds, id => !_.includes(filteredIds, id));
          } else {
            $scope.selectedIds = _.union($scope.selectedIds, filteredIds);
          }
        }
        $scope.onRemoveAllocationResource = (chip) => {
          $scope.selectedIds = _.filter($scope.selectedIds, (id) => {
            return id !== chip.id;
          });
        }

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        //        Public methods
        // ******************************

        $scope.submit = () => {
          const selectedResources = _.filter($scope.resources, (r) => {
            return !_.includes(projectResourceIds, r.id) &&
              _.includes($scope.selectedIds, r.id);
          });
          $mdDialog.hide({
            selectedResources: selectedResources,
            importAllocationResourcesServiceTemplate: $scope.queryParams.importAllocationResourcesServiceTemplate
          });
        }

        ///////////////////////////////////////////////////////////////


        function _initResources() {
          $scope.resources = [];
          $scope.selectedIds = angular.copy(projectResourceIds) || [];
          $scope.loading = true;

          planningRequestsService.getAllocationResources(from, to, projectId, $scope.branchIds, $scope.agentSkills, $scope.agentIds,
            $scope.agentTags, $scope.vehicleTypeIds, $scope.vehicleTypes, $scope.filterOutWithoutAgent, $scope.filterOutNotAvailableVehicle, $scope.excludedAgentTags, $scope.excludeAllocationsBeforeFromDate, $scope.resourceTags)
            .then((resources) => {
              $scope.resources = _.map(resources, (r) => {
                _.set(r, 'id', r.allocationId + '_' + r.startTime + '_' + r.endTime);
                return r;
              });
            })
            .catch(() => {
              planningAlertsService.getResourcesError();
            })
            .finally(() => {
              $scope.loading = false;
            });
        }
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  selectVehicleResources(from, to, projectId, branchIds, projectResourceIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/select-vehicle-resources-dialog.html').default,
      controller: function ($scope, planningRequestsService, planningAlertsService: PlanningAlertsService) {

        $scope.projectResourceIds = projectResourceIds;

        $scope.resources = [];
        $scope.selectedIds = [];
        $scope.loading = false;
        $scope.queryString = undefined;
        $scope.labelsIds = undefined;
        $scope.vehicleTypes = undefined;
        $scope._initResources = () => {
          $scope.resources = [];
          $scope.selectedIds = angular.copy(projectResourceIds) || [];
          $scope.loading = true;

          planningRequestsService.getVehicleResources(projectId, $scope.vehicleTypes, $scope.labelsIds, $scope.queryString)
            .then((resources) => {
              $scope.resources = resources;
            })
            .catch(() => {
              planningAlertsService.getResourcesError();
            })
            .finally(() => {
              $scope.loading = false;
            });
        }

        $scope._initResources();

        // ******************************
        //        Public methods
        // ******************************


        $scope.onQueryChange = (queryString) => {
          $scope.queryString = queryString;
          $scope._initResources()
        }

        $scope.onLabelsIdChange = (selectedIds) => {
          $scope.labelsIds = selectedIds;
          $scope._initResources()
        }

        $scope.onVehicleClassChanged = (selectedIds) => {
          $scope.vehicleTypes = selectedIds;
          $scope._initResources()
        }
        $scope.onResourceSelect = (resource) => {
          $scope.selectedIds.push(resource.vehicleId);
        }
        $scope.onRemoveAllocationResource = (chip) => {
          $scope.selectedIds = _.filter($scope.selectedIds, (id) => {
            return id !== chip.id;
          })
        }
        $scope.onRemoveVehicleResource = (resource) => {
          $scope.selectedIds = _.filter($scope.selectedIds, (id) => {
            return id !== resource.vehicleId;
          })
        }
        $scope.onClearSelection = () => {
          $scope.selectedIds = [];
        }
        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = () => {
          const selectedResources = _.filter($scope.resources, (r) => {
            return !_.includes(projectResourceIds, r.vehicleId) &&
              _.includes($scope.selectedIds, r.vehicleId);
          })
          self.$mdDialog.hide(selectedResources);
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  selectAgentsScheduleResources(from, to, projectId, branchIds, projectResourceIds, enabledExcludeModeFilters: {
    [key: string]: boolean
  }, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/select-agents-schedule-resources-dialog.html').default,
      controller: function ($scope, planningRequestsService, planningAlertsService: PlanningAlertsService, $mdDialog, $filter) {

        $scope.projectResourceIds = projectResourceIds;

        $scope.resources = [];
        $scope.agentTypes = [];
        $scope.agentSkills = [];
        $scope.selectedIds = [];
        $scope.loading = false;
        $scope.projectBranchIds = branchIds; //Should not be deselected
        $scope.enabledExcludeModeFilters = enabledExcludeModeFilters;
        $scope.siteFilterTypes = SiteFiltersType;

        //filters
        $scope.queryString = undefined;
        $scope.branchIds = branchIds;
        $scope.agentIds = undefined;
        $scope.vehicleTypeIds = undefined; // type
        $scope.vehicleTypes = undefined // class
        _initResources();

        $scope.onQueryChange = (queryString) => {
          $scope.queryString = queryString;
        }

        $scope.onAgentTypesChange = (agentTypes) => {
          $scope.agentTypes = agentTypes;
          _initResources();
        }

        $scope.onBranchesSelect = (selectedIds) => {
          $scope.branchIds = selectedIds.length ? selectedIds : $scope.projectBranchIds;
          _initResources();
        }

        $scope.onAgentsSelect = (selectedIds) => {
          $scope.agentIds = selectedIds;
          _initResources();
        }

        $scope.onAgentTagsSelect = (tags, isExcludeMode) => {
          if (isExcludeMode) {
            $scope.agentTags = undefined;
            $scope.excludedAgentTags = tags;
          } else {
            $scope.agentTags = tags;
            $scope.excludedAgentTags = undefined;
          }

          _initResources();
        }

        $scope.onAgentSkillsSelect = (skills) => {
          $scope.agentSkills = skills;
          _initResources();
        }

        $scope.onResourceToggle = (resource) => {
          const isInclude = _.includes($scope.selectedIds, resource.id)

          if (isInclude) {
            $scope.selectedIds = _.filter($scope.selectedIds, (i) => {
              return i !== resource.id;
            })
          } else {
            $scope.selectedIds.push(resource.id);
          }
        }

        $scope.getFilteredResources = () => {
          if (!$scope.queryString || $scope.queryString.trim() === '') {
            return $scope.resources;
          }

          return $filter('filter')($scope.resources, $scope.queryString);
        };

        $scope.onResourceToggleAll = () => {
          const filteredResources = $scope.getFilteredResources();
          const filteredIds = _.map(filteredResources, 'id');

          const allFilteredSelected = filteredIds.length > 0 &&
            _.every(filteredIds, id => _.includes($scope.selectedIds, id));

          if (allFilteredSelected) {
            $scope.selectedIds = _.filter($scope.selectedIds, id => !_.includes(filteredIds, id));
          } else {
            $scope.selectedIds = _.union($scope.selectedIds, filteredIds);
          }
        }
        $scope.onRemoveAllocationResource = (chip) => {
          $scope.selectedIds = _.filter($scope.selectedIds, (id) => {
            return id !== chip.id;
          });
        }

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        //        Public methods
        // ******************************

        $scope.submit = () => {
          const selectedResources = _.filter($scope.resources, (r) => {
            return !_.includes(projectResourceIds, r.id) &&
              _.includes($scope.selectedIds, r.id);
          });
          $mdDialog.hide(selectedResources);
        }

        ///////////////////////////////////////////////////////////////


        function _initResources() {
          $scope.resources = [];
          $scope.selectedIds = angular.copy(projectResourceIds) || [];
          $scope.loading = true;

          planningRequestsService.getAgentScheduleResources(from, to, $scope.branchIds, $scope.agentTypes, $scope.agentIds, $scope.agentTags, $scope.agentSkills, $scope.excludedAgentTags)
            .then((resources) => {
              $scope.resources = _.map(resources, (r) => {
                _.set(r, 'id', r.instanceResourceId);
                return r;
              });
            })
            .catch(() => {
              planningAlertsService.getResourcesError();
            })
            .finally(() => {
              $scope.loading = false;
            });
        }
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }


  // createRouteToDraftOLD(resources, hasLeftovers, event) {
  //   return this.$mdDialog.show({
  //     parent: angular.element(document.body),
  //     template: require('./../views/dialogs/planning-draft-create-route-dialog.html').default,
  //     controller: ($scope, $filter) => {
  //
  //       $scope.resources = resources;
  //       $scope.selectedResource = undefined;
  //
  //       $scope.addLeftovers = {
  //         enabled: hasLeftovers
  //       };
  //
  //       // ******************************
  //       //        Public methods
  //       // ******************************
  //       $scope.cancel = this.$mdDialog.cancel;
  //       $scope.submit = () => {
  //         const payload = {
  //           resource: $scope.selectedResource,
  //           addLeftovers: $scope.addLeftovers.enabled
  //         };
  //         this.$mdDialog.hide(payload);
  //       }
  //
  //       $scope.getSelectedResourceName = (resource) => {
  //         if (!resource) {
  //           return $filter('translate')('Select resource');
  //         }
  //         return resource.vehicleName || resource.allocationName;
  //       }
  //       $scope.onResourceSelect = (resource) => {
  //         $scope.selectedResource = resource;
  //       }
  //
  //       // ******************************
  //       //        Private methods
  //       // ******************************
  //
  //       function _getResources() {
  //         $scope.loading = true;
  //         planningRequestsService.getResources(projectId)
  //           .then(function (resources) {
  //             $scope.resources = resources;
  //           })
  //           .catch(function (err) {
  //             planningAlertsService.getResourcesError();
  //           })
  //           .finally(function () {
  //             $scope.loading = false;
  //           });
  //       }
  //
  //     },
  //     targetEvent: event,
  //     clickOutsideToClose: false
  //   })
  // }


  createRouteToDraft(resources, selectedJobs, projectId, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/planning-draft-create-route-dialog.html').default,
      controller: function ($scope, $filter, planningAlertsService: PlanningAlertsService, planningRequestsService: PlanningRequestsService) {

        $scope.routeName = undefined;
        $scope.resources = resources;
        $scope.selectedResource = undefined;
        $scope.selectedJobs = selectedJobs;
        $scope.isExistingResource = true;

        $scope.selectedJobsPackages = _.flatMap($scope.selectedJobs, 'packages');
        $scope.spots = $filter('orderSpots')($scope.selectedJobsPackages);
        $scope.weight = $filter('jobPackagesWeight')($scope.selectedJobsPackages);
        $scope.volume = $filter('jobPackagesVolume')($scope.selectedJobsPackages);
        $scope.packages = $filter('servicePackagesCount')($scope.selectedJobsPackages);
        $scope.pallets = $filter('servicePackagesCount')($scope.selectedJobsPackages);

        $scope._initResources = () => {
          $scope.loading = true;

          planningRequestsService.getVehicleResources(projectId, $scope.vehicleTypes, $scope.labelsIds, $scope.queryString)
            .then((resources) => {
              $scope.vehicleResources = resources;

              $scope.resourceOptionsWrapper = {
                list: resources?.map(r => {
                  return {id: r.vehicleId, name: r.vehicleName}
                }), propertyRef: 'name'
              };

            })
            .catch(() => {
              planningAlertsService.getResourcesError();
            })
            .finally(() => {
              $scope.loading = false;
            });
        }

        $scope._initResources();

        $scope.onResourceSelect = (resource) => {
          $scope.selectedResource = resource;
        }

        $scope.onSelectVehicleResource = (vehicleResourceId) => {
          const vehicleResource = $scope.vehicleResources.find((vr) => vr.vehicleId === vehicleResourceId);
          $scope.selectedResource = vehicleResource;
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = () => {
          self.$mdDialog.hide({
            resource: $scope.selectedResource,
            routeName: $scope.routeName,
            isExistingResource: $scope.isExistingResource
          });
        }
      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  updateRouteToDraft(routes, selectedJobs, validateRouteResourceVehicle, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/planning-draft-update-route-dialog.html').default,
      controller: function ($scope, $filter) {

        $scope.routes = _.filter(routes, (r) => {
          return !r.locked;
        });
        $scope.selectedJobs = selectedJobs;
        $scope.selectedRoute = undefined;
        $scope.optimize = {
          enabled: true
        };
        $scope.selectedJobsPackages = _.flatMap($scope.selectedJobs, 'packages');
        $scope.spots = $filter('orderSpots')($scope.selectedJobsPackages);
        $scope.weight = $filter('jobPackagesWeight')($scope.selectedJobsPackages);
        $scope.volume = $filter('jobPackagesVolume')($scope.selectedJobsPackages);
        $scope.packages = $filter('servicePackagesCount')($scope.selectedJobsPackages);

        // ******************************
        //        Public methods
        // ******************************

        $scope.onRouteSelected = (route) => {
          $scope.selectedRoute = route;

          if (validateRouteResourceVehicle) {
            $scope.isShowRouteResourceVehicleMismatchWarning = false;
            for (let job of $scope.selectedJobs) {
              const jobVehicleTypes = _.map(job.allowedVehicleReferences, 'type');
              if (!!route.resource?.vehicleClass &&
                jobVehicleTypes?.length && !jobVehicleTypes.includes(route.resource?.vehicleClass)) {
                $scope.isShowRouteResourceVehicleMismatchWarning = true;
                break;
              }
            }
          }
        }
        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = () => {
          const payload = {
            route: $scope.selectedRoute,
            optimize: $scope.optimize.enabled
          };
          self.$mdDialog.hide(payload);
        }

      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  selectDepots(projectId, originalDepots, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/select-depots-dialog.html').default,
      controller: function ($scope, planningRequestsService, planningAlertsService: PlanningAlertsService) {

        $scope.depots = [];
        $scope.originalDepotSyncIds = _.map(originalDepots, 'syncId');
        $scope.selectedIds = _.map(originalDepots, 'syncId');
        $scope.depotChips = _.map(originalDepots, (d) => {
          return {
            id: d.syncId,
            name: d.name,
            ref: d
          }
        });

        _getDepots();

        // ******************************
        //        Public methods
        // ******************************


        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = () => {
          const originalDepotIds = _.map(originalDepots, 'id');
          const selectedDepots = _.chain($scope.depotChips)
            .map((d) => {
              return d.ref;
            })
            .filter((depot) => {
              return !_.includes(originalDepotIds, depot.id);
            })
            .uniq()
            .value();
          self.$mdDialog.hide(selectedDepots);
        }
        $scope.onDepotSelect = (depot) => {
          if (depot) {
            const chip = {
              id: depot.syncId,
              name: depot.name,
              ref: depot
            };
            $scope.selectedIds.push(depot.syncId);

            $scope.depotChips.push(chip);
            $scope.depotChips = _.uniqBy($scope.depotChips, 'id');
          }
        }
        $scope.onRemoveDepot = (chip) => {
          $scope.selectedIds = _.filter($scope.selectedIds, (id) => {
            return id !== chip.id;
          });
        }
        $scope.onClearSelection = () => {
          $scope.selectedIds = [];
          $scope.depotChips = [];
        }
        $scope.isDisableConfirm = () => {
          if (!$scope.depotChips.length) {
            return true
          }

          return _.isEqual($scope.originalDepotSyncIds, $scope.selectedIds);
        }

        // ******************************
        //        Private methods
        // ******************************

        function _getDepots() {
          $scope.loading = true;
          planningRequestsService.getDepots(projectId)
            .then((depots) => {
              $scope.depots = depots;
            })
            .catch(function (error) {
              planningAlertsService.getDepotsError();
            })
            .finally(function () {
              $scope.loading = false;
            });
        }

      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  ProjectOptimizingLoader(isEnabled, event?) {

    if (!isEnabled) {
      // Only close the loader when we actually opened it - otherwise this would blindly hide
      // whatever $mdDialog happens to be on top (see draftOptimizingLoader for the same fix).
      if (!this._isProjectOptimizingLoaderShowing) {
        return;
      }
      this._isProjectOptimizingLoaderShowing = false;
      return this.$mdDialog.hide();
    }

    const isProjectLoaderOn = angular.element(document.body).hasClass('md-dialog-is-showing');

    if (isProjectLoaderOn) {
      return;
    }

    this._isProjectOptimizingLoaderShowing = true;

    return this.$mdDialog.show({
      // parent: angular.element(document.body),
      parent: angular.element(document.querySelector('#planning-project-view-container')),
      template: require('./../views/dialogs/project-optimizing-loader-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: false,
      controller: function ($scope) {

      }
    }).finally(() => {
      this._isProjectOptimizingLoaderShowing = false;
    })
  }


  ProjectImportLoader(projectProcess, event?) {
    const self = this;
    return this.$mdDialog.show({
      // parent: angular.element(document.body),
      parent: angular.element(document.querySelector('#planning-project-view-container')),
      template: require('./../views/dialogs/project-import-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: false,
      controller: function ($scope, planningProjectProcessTrackingRequestsService, $timeout,
                            pollingIntervalService: PollingIntervalService, $log) {
        const INTERVAL = 5000;

        $scope.process = angular.copy(projectProcess);

        $scope.isDone = $scope.process.processStatus !== 'IN_PROGRESS';

        const onProcessUpdate = (updatedProcess) => {
          if (updatedProcess.processStatus !== 'IN_PROGRESS') {
            $scope.isDone = true;
            $scope.process = updatedProcess;
          }
          if (!$scope.isDone) {
            $scope.process = updatedProcess;
          }
        };

        // Push events can arrive out of order (COMPLETED before IN_PROGRESS), so poll until a final status is reached
        const poller = pollingIntervalService.start($scope, () => {
          if ($scope.isDone) {
            poller.cancel();
            return;
          }
          planningProjectProcessTrackingRequestsService.getProjectProcesses(projectProcess.processId)
            .then((processes) => {
              const updatedProcess = _.find(processes, {id: projectProcess.id});
              if (updatedProcess) {
                onProcessUpdate(updatedProcess);
              }
            })
            .catch((error) => $log.error('Failed to get import process', error));
        }, INTERVAL);

        $scope.submit = () => {
          self.$mdDialog.hide();
        }

      }
    })
  }

  draftOptimizingLoader(isEnabled, projectId?, draft?) {

    const self = this;
    if (!isEnabled) {
      // Only close the loader when we actually opened it. Otherwise a live draft
      // update (e.g. after persisting clustering areas from an open settings dialog)
      // would hide whatever $mdDialog is currently on top.
      if (!this._isDraftOptimizingLoaderShowing) {
        return;
      }
      this._isDraftOptimizingLoaderShowing = false;
      return this.$mdDialog.hide();
    }

    const isDraftLoaderOn: boolean = angular.element(document.body).hasClass('md-dialog-is-showing');

    if (isDraftLoaderOn) {
      return;
    }

    this._isDraftOptimizingLoaderShowing = true;

    return this.$mdDialog.show({
      parent: angular.element(document.querySelector('#planning-project-draft-view-container')),
      template: require('./../views/dialogs/draft-optimizing-loader-dialog.html').default,
      // targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: false,
      controller: function ($scope, $drafts, $interval, $timeout, planningConstants, planningDraftsService) {

        const draftRef = $drafts(draft.id),
          MESSAGES = planningConstants.loadingMessages,
          INTERVAL = 5000;
        let cursor = _getCursorByProgress(draft.optimizationProgress);

        $scope.draft = draft;
        $scope.aborting = false;
        $scope.bufferValue = 100;
        $scope.text = MESSAGES[cursor];

        draftRef.$registerOnUpdateHandler($scope, (updatedDraft) => {
          if (_.isEqual($scope.draft.id, updatedDraft.id)) {
            $scope.draft = updatedDraft;
          }
        });

        $interval(() => {
          const updatedCursor = _getCursorByProgress($scope.draft.optimizationProgress);

          if (updatedCursor !== cursor) {
            cursor = updatedCursor;
            _setText(cursor);
          }
        }, INTERVAL);

        $scope.abort = () => {
          $scope.aborting = true;
          planningDraftsService.abortOptimizeDraft(draft.id, projectId)
            .finally(() => {
              draftRef.$destroy();
              self.$mdDialog.hide();
            })
        }


        ////////////////// private methods //////////////////////
        function _getCursorByProgress(progress) {
          return progress >= 75 ? 3 :
            ((progress >= 50 && progress < 75) ? 2 :
              (progress >= 25 && progress < 50) ? 1 : 0);
        }

        function _setText(cursor) {
          $scope.text = undefined;
          $timeout(500).then(() => {
            $scope.text = MESSAGES[cursor];
          })
        }


      }
    }).finally(() => {
      this._isDraftOptimizingLoaderShowing = false;
    })
  }


  draftDispatchingLoader(projectId?, draftId?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/draft-dispatching-loader-dialog.html').default,
      controller: function ($scope, $log, $interval, planningRequestsService, batchRequestsService: BatchRequestsService, $planningProjects) {

        $scope.isDispatched = false;
        $scope.hasFailed = false;
        $scope.isDispatchedpartially = false;

        const projectRef = $planningProjects(projectId);
        projectRef.$bind($scope, 'project');
        projectRef.$registerOnUpdateHandler($scope, (updatedProject) => {


          if (_.isEqual(updatedProject.id, projectId)) {
            $log.info('PROJECT DISPATCHING PUSH', updatedProject);


            if (_.isEqual(updatedProject.status, 'SCHEME')) {
              $scope.hasFailed = true;
            }

            if (_.isEqual(updatedProject.status, 'DISPATCHED')) {
              if (updatedProject.projectDispatchProgress.services.failed || updatedProject.projectDispatchProgress.routes.failed) {
                $scope.isDispatchedpartially = true;
              } else {
                $scope.isDispatched = true;
              }
            }

            // if (_.isEqual(updatedProject.status, 'DISPATCHED') &&
            //     _.get(updatedProject, 'projectDispatchProgress.services.done', false) &&
            //     _.get(updatedProject, 'projectDispatchProgress.routes.done', false)) {
            //     $scope.isDispatched = true;
            // }
          }

        });

        // ******************************
        //        Public methods
        // ******************************

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = () => {
          self.$mdDialog.hide();
        }
      },
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: false
    })

  }

  // Polls processTracking until no in-progress Draft Job Changes scan/apply remains for this
  // draft, then closes.
  //
  // `trigger`/`filter` kick off a scan or apply when the dialog opens (used for the "never
  // scanned" entry point, Rescan, and Apply) — the POST is awaited and only once it resolves does
  // polling begin, so a process genuinely exists (or the request is known to have created none, in
  // which case we never poll at all) before the first processTracking check. Polling before that
  // response lands is a race: the check can run before the batch/process is even created and read
  // "nothing in progress", closing the dialog immediately as if the operation had already finished.
  // Omit both when only an already-running apply/scan needs to be observed (e.g. reopening on a
  // draft whose jobChangesSyncState is already SCANNING/APPLYING).
  draftJobChangesProcessingDialog(project, draft, event?, trigger?: 'scan' | 'apply', filter?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.querySelector('#planning-project-draft-view-container')) ||
        angular.element(document.body),
      template: require('./../views/dialogs/draft-job-changes-processing-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: false,
      controller: function ($scope, pollingIntervalService, planningDraftJobChangesHttpService, planningAlertsService: PlanningAlertsService) {
        $scope.draft = draft;
        $scope.isApplying = trigger === 'apply' || draft.jobChangesSyncState === DraftJobChangesSyncState.APPLYING;
        $scope.cancel = self.$mdDialog.cancel;

        // progressMap is keyed by ProcessTrackingMeasurementTypeEnum (e.g. "Job": {total, created,
        // existed, updated, failed}) — same shape scheduling-project-processing-dialog.html reads,
        // summed across every measurement the process reports rather than assuming just one key.
        const computeProgress = (process): number => {
          const progressMap = process?.progressMap;
          if (!progressMap) {
            return 0;
          }
          const totals = _.reduce(progressMap, (acc: { total: number, done: number }, value: any) => {
            acc.total += value?.total || 0;
            acc.done += (value?.created || 0) + (value?.existed || 0) + (value?.updated || 0) + (value?.failed || 0);
            return acc;
          }, {total: 0, done: 0});
          return totals.total ? (totals.done / totals.total) * 100 : 0;
        };

        const startPolling = () => {
          const checkProcess = () => {
            planningDraftJobChangesHttpService.getProcessTracking(project.id, draft.id, {status: 'IN_PROGRESS'})
              .subscribe({
                next: (processTracking) => {
                  if (!processTracking || !processTracking.length) {
                    poller.cancel();
                    self.$mdDialog.hide();
                    return;
                  }
                  $scope.processTracking = _.last(processTracking);
                  $scope.progress = computeProgress($scope.processTracking);
                },
                error: () => {
                  poller.cancel();
                  self.$mdDialog.hide();
                }
              });
          };

          const poller = pollingIntervalService.start($scope, checkProcess, 5000);
          checkProcess();
        };

        const triggerRequest = trigger === 'scan' ? planningDraftJobChangesHttpService.scan(project.id, draft.id) :
          trigger === 'apply' ? planningDraftJobChangesHttpService.apply(project.id, draft.id, filter) :
            null;

        if (triggerRequest) {
          triggerRequest.subscribe({
            next: () => startPolling(),
            error: (error) => {
              // Either the request outright failed, or it succeeded in the sense that mattered
              // (e.g. code 400483 "nothing to process") without ever creating a process — either
              // way there is nothing to poll for.
              if (!planningAlertsService.handleDraftJobChangesError(error)) {
                if (trigger === 'scan') {
                  planningAlertsService.scanDraftJobChangesError();
                } else {
                  planningAlertsService.applyDraftJobChangesError();
                }
              }
              self.$mdDialog.hide();
            }
          });
        } else {
          startPolling();
        }
      }
    })
  }

  onViewDraftJobChanges(project, draft, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/draft-job-changes-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, confirmDialogService: ConfirmDialogService, planningDraftJobChangesFacadeService) {
        $scope.project = project;
        $scope.draft = draft;
        $scope.selectedIds = [];
        $scope.selectAllMatching = false;
        $scope.jobChangesSyncEnabled = !!_.get(draft, 'settings.jobChangesSyncEnabled');

        let currentFilter: any = {};

        const selectedIdsSubscription = planningDraftJobChangesFacadeService.selectSelectedIds()
          .subscribe((selectedIds) => {
            $scope.selectedIds = selectedIds;
            $scope.$applyAsync();
          });

        const selectAllMatchingSubscription = planningDraftJobChangesFacadeService.selectSelectAllMatching()
          .subscribe((selectAllMatching) => {
            $scope.selectAllMatching = selectAllMatching;
            $scope.$applyAsync();
          });

        // The exact filter behind whatever the list is currently showing (kept in sync by the list
        // component on every fetch) — reused as-is for "select all matching" apply/dismiss, since
        // an apply/dismiss filter with no `ids` is treated server-side as "everything matching".
        const filtersSubscription = planningDraftJobChangesFacadeService.selectFilters()
          .subscribe((filters) => {
            currentFilter = filters || {};
          });

        $scope.$on('$destroy', () => {
          selectedIdsSubscription.unsubscribe();
          selectAllMatchingSubscription.unsubscribe();
          filtersSubscription.unsubscribe();
          planningDraftJobChangesFacadeService.clearStore();
        });

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onRescan = () => {
          self.$mdDialog.hide();
          self.draftJobChangesProcessingDialog(project, draft, event, 'scan')
            .finally(() => self.onViewDraftJobChanges(project, draft, event));
        };

        // `ids` selection applies/dismisses exactly those rows; "select all matching" sends the
        // active filter instead (no `ids`), which the server resolves against the whole draft.
        const buildSelectionFilter = () => $scope.selectAllMatching ? currentFilter : {ids: $scope.selectedIds};

        $scope.onApply = () => {
          confirmDialogService.confirm('PLANNING_DRAFT_JOB_CHANGES_APPLY_CONFIRM_TITLE', 'PLANNING_DRAFT_JOB_CHANGES_APPLY_CONFIRM_TEXT', event)
            .then(() => {
              self.$mdDialog.hide();
              self.draftJobChangesProcessingDialog(project, draft, event, 'apply', buildSelectionFilter())
                .finally(() => self.onViewDraftJobChanges(project, draft, event));
            })
            .catch(() => {
            });
        };

        $scope.onDismiss = () => {
          confirmDialogService.confirm('PLANNING_DRAFT_JOB_CHANGES_DISMISS_CONFIRM_TITLE', 'PLANNING_DRAFT_JOB_CHANGES_DISMISS_CONFIRM_TEXT', event)
            .then(() => {
              planningDraftJobChangesFacadeService.dismiss(project.id, draft.id, buildSelectionFilter());
            })
            .catch(() => {
            });
        };
      }
    })
  }

  // TODO Deprecated
  approveAndDispatchDraft(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/approve-and-dispatch-draft-dialog.html').default,
      controller: function ($scope) {

        $scope.accountId = undefined;

        $scope.onAccountSelect = (account: AccountModel) => {
          $scope.accountId = account.id;
        }
        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        //        Public methods
        // ******************************
        $scope.submit = () => {
          self.$mdDialog.hide($scope.accountId);
        }


      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  jobsOutOfProjectScope(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/jobs-out-of-project-scope-dialog.html').default,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        //        Public methods
        // ******************************

        $scope.submit = () => {
          self.$mdDialog.hide(true);
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }


  approveAndDispatch(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/approve-and-dispatch-dialog.html').default,

      controller: function ($scope) {

        $scope.autoAssignRoutes = false;
        $scope.dispatchLeftovers = false;
        $scope.keepProjectOpen = false;


        // ******************************
        //        Public methods
        // ******************************

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = () => {
          self.$mdDialog.hide({
            autoAssignRoutes: $scope.autoAssignRoutes,
            dispatchLeftovers: $scope.dispatchLeftovers,
            keepProjectOpen: $scope.keepProjectOpen
          });
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  selectActivity(activities?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/select-activity-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.activities = activities;
        $scope.selectedIds = [];

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onSelectedChange = (selectedIds) => {
          $scope.selectedIds = selectedIds;
        }

        $scope.submit = () => {
          if ($scope.selectedIds.length) {
            const selectedActivities = _.filter($scope.activities, (a) => {
              return _.includes($scope.selectedIds, a.id);
            })
            self.$mdDialog.hide(selectedActivities);
          }
        }

        $scope.submitAll = () => {
          self.$mdDialog.hide(activities);
        }


      }
    })
  }

  viewJob(job, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/view-job-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.job = job;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////


      }
    })
  }

  viewJobs(jobs, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/view-job-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $timeout) {

        $scope.jobs = jobs;
        $scope.job = jobs[0];

        $scope.onServiceSelect = (job) => {
          $scope.job = job;
          $timeout(0).then(() => {});
        }

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////


      }
    })
  }

  exportDraftLoadingSheet(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/export-draft-loading-sheet-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.email = undefined;

        $scope.onEmailChange = (email) => {
          $scope.email = email;
        }

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted();
            if (form.$valid) {
              self.$mdDialog.hide($scope.email);
            }
          }
        }


      }
    })
  }

  draftOverview(draft, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/draft-overview-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.draft = draft;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////


      }
    })
  }

  editDraftResourceAllocation(resource, routeId?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/planning-draft-resource-allocation-dialog.html').default,
      controller: function ($scope, $log, $filter, agentConstants, planningConstants, splitService, moment) {
        $scope.header = 'Edit Resource Allocation';
        $scope.isRouted = !!routeId;

        // Form tabs
        $scope.selectedTab = 'resourceDetails';
        $scope.tabs = ['resourceDetails', 'routeSettings', 'agentDetails', 'timeSettings'];

        // Skill options
        $scope.skillOptions = [ResourceSkill.Delivery, ResourceSkill.Merchandise, ResourceSkill.Order, ResourceSkill.AutonomousAgent];

        // Service types
        $scope.serviceAreaTypes = ['Planning'];

        // Vehicle types
        $scope.vehicleTypeIds = resource.vehicleType? [resource.vehicleType.id] : [];
        $scope.logisticsVehicleTypeIds = resource.vehicleId ? [resource.vehicleId] : undefined;
        $scope.attachedLogisticsVehicleIds = _.flatMap(resource.attachedLogisticsVehicleReferences, 'id')

        $scope.resource = angular.copy(resource);

        // Initialize routeIncomePreferences if it doesn't exist
        if (!$scope.resource.routeIncomePreferences) {
          $scope.resource.routeIncomePreferences = {
            considerMinimumRouteIncome: false,
            considerMaximumRouteIncome: false
          };
        }

        // Flags
        $scope.isSupportResourcePriority = true;
        $scope.isEnableResourceAgentTypeEditing = true;
        $scope.limitingSingleTimezone = false;
        $scope.canAddServiceAreasToTw = false;
        $scope.enableAllocationBranchSupport = true;
        $scope.isBranchesChanged = false;

        $scope.cancel = self.$mdDialog.cancel;

        // Form validation
        $scope.hasErrorsInTab = (tabName) => {
          return false;
        };

        $scope.onSelectTab = (tab) => {
          $scope.selectedTab = tab;
        };

        $scope.onBranchIdsChange = (selectedIds) => {
          $scope.resource.branchIds = selectedIds;
          $scope.isBranchesChanged = true;
          $scope.resource.mainLogisticsVehicleId = null;
          $scope.resource.attachedLogisticsVehicleIds = [];
        };

        $scope.onSelectServiceAreas = (ids) => {
          $scope.resource.areaIds = ids;
        };

        $scope.onLocationSettingsChange = (locationSettings) => {
          $scope.resource.locationSettings = locationSettings;
        };

        $scope.onEnforceLocationsChange = (enforceLocations) => {
          $scope.resource.enforceLocations = enforceLocations;
        };


        $scope.onSkillSelect = (skills) => {
          $scope.resource.allocationSkills = skills;
        };

        $scope.onTagsChange = (ids) => {
          $scope.resource.tags = ids;
        };

        $scope.onSelectDefaultAgent = (agentBinding) => {
          $scope.resource.agentId = agentBinding?.agentId;
        };
        $scope.onAgentTypeChange = (agentType) => {
          $scope.resource.agentType = agentType;
        };

        $scope.onVehicleSelect = (vehicle) => {
          $scope.resource.vehicleType = vehicle ? {
            id: vehicle.id,
            name: vehicle.name,
            type: vehicle.type,
          } : undefined
          $scope.vehicleTypeIds = vehicle ? [vehicle.id] : [];
          $scope.resource.vehicle = vehicle;
          $scope.logisticsVehicleTypeIds = [];
          $scope.attachedLogisticsVehicleIds = [];

          if (!!$scope.resource.mainLogisticsVehicleReference) {
            $scope.resource.mainLogisticsVehicleReference = undefined
          }

          if (!!$scope.resource.attachedLogisticsVehicleReferences?.length) {
            $scope.resource.attachedLogisticsVehicleReferences = []
          }

        };

        $scope.onLogisticsVehicleSelect = (logisticsVehicle) => {
          $scope.resource.vehicleId = logisticsVehicle?.id;
          $scope.resource.mainLogisticsVehicleReference = logisticsVehicle ? {
            id: logisticsVehicle.id,
            externalId: logisticsVehicle.externalId,
            name: logisticsVehicle.name,
            vehicleTypeId: logisticsVehicle.vehicleTypeId,
            licensePlateNumber: logisticsVehicle.licensePlateNumber,
            vehicleType: logisticsVehicle.vehicleType
          } : null;
        }

        $scope.onAttachedLogisticsVehicleSelect = (logisticVehicles) => {
          $scope.attachedLogisticsVehicleIds = logisticVehicles ? _.flatMap(logisticVehicles, 'id') : [];
          $scope.resource.attachedLogisticsVehicleReferences = logisticVehicles ? logisticVehicles.map((l) => {
            return {
              id: l.id,
              externalId: l.externalId,
              name: l.name,
              vehicleTypeId: l.vehicleTypeId,
              licensePlateNumber: l.licensePlateNumber,
              vehicleType: l.vehicleType
            }
          }) : [];
        };

        $scope.onTimeRangeChange = (from, to) => {
          $scope.resource.startTime = from;
          $scope.resource.endTime = to;
        };

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.resource);
            }
          }
        };

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    });
  }

  preAssignAgentToRoutes(routes, currentAgentId?: string, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/pre-assign-agent-dialog.html').default,
      controller: function ($scope, resizeService) {
        $scope.selectedAgentId = currentAgentId;
        $scope.routes = routes;
        $scope.skills = _.chain(routes)
          .flatMap('resource.allocationSkills')
          .compact()
          .uniq()
          .value();

        $scope.onReload = () => {
          resizeService.resize();
        }

        $scope.onQueryStringChanged = (query) => {
          $scope.queryString = query;
        }

        $scope.onAgentSelect = (selectedId) => {
          $scope.selectedAgentId = selectedId;
        };

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.selectedAgentId);
            }
          }
        };
      },
      targetEvent: event,
      clickOutsideToClose: false
    });
  }

  editPickingTime(routes, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-picking-time-dialog.html').default,
      controller: function ($scope) {
        $scope.routes = routes;

        const earliestStartTime = _.chain(routes)
          .map((route) => _.get(route, 'activities[0].eta', _.get(route, 'activities[0].notBefore')))
          .compact()
          .map((startTime) => moment(startTime).valueOf())
          .min()
          .value();

        $scope.pickingTime = earliestStartTime;
        $scope.timeConfig = {
          min: moment(earliestStartTime).startOf('day').valueOf(),
          max: earliestStartTime
        };

        $scope.onPickingTimeChange = (pickingTime) => {
          $scope.pickingTime = pickingTime;
        };

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.pickingTime);
            }
          }
        };
      },
      targetEvent: event,
      clickOutsideToClose: false
    });
  }

  projectsInfo(project, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/projects-info-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.project = project;
        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = () => {
          self.$mdDialog.hide();
        };

      }
    })
  }

  openKpiDialog(accountsData, solutionData, event?) {
    // Prevent multiple dialogs from opening
    const self = this;
    this.$mdDialog.cancel();

    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/planning-kpi-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope, $q) {

        // Initialize selected section (default to Account Summary)
        $scope.selectedSection = 'accountSummary';

        // Initialize loading state for account data
        $scope.isLoadingAccountData = true;
        $scope.isLoadingSolutionData = true;

        // Calculate passed status for each account: numberOfTrips <= neededVehicles
        if (accountsData && Array.isArray(accountsData)) {
          accountsData.forEach((account) => {
            account.passed = account.numberOfTrips <= account.neededVehicles;
          });
        }

        $scope.accountsData = accountsData;
        $scope.solutionData = solutionData;



        // Dialog actions
        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = () => {
          self.$mdDialog.hide();
        };

      }
    })
  }

  openBulkJobSplitDialog(suggestions: JobSuggestion[], event) {
    const self = this;
    this.$mdDialog.cancel();
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('../views/dialogs/planning-bulk-job-split.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope, $q) {
        // variables
        $scope.suggestions = suggestions;

        // functions
        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (form) => {
          if (form) {
            if($scope.suggestions.filter(suggestion => suggestion.decision).length === 0) {
              let message = {
                details: 'COMMONS_FORM_INVALID_INFO',
                body: 'PLEASE_MAKE_A_DECISION_FOR_AT_LEAST_ONE_SPLIT_SUGGESTION'
              };
              self.bringozToastService.info(message);
              return;
            }
            form.$setSubmitted(true);
            if (form.$valid) {
              let suggestionsDecisions: {approve, deny, optimize} =
                $scope.suggestions.reduce((acc, suggestion) => {
                  switch (suggestion.decision) {
                    case JobSuggestionDecision.APPROVED:
                      acc.approve.push(suggestion);
                      break;
                    case JobSuggestionDecision.DENY:
                      acc.deny.push(suggestion);
                      break;
                    case JobSuggestionDecision.OPTIMIZE:
                      acc.optimize.push(suggestion);
                      break;
                  }
                  return acc;
                }, {
                  approve: [],
                  deny: [],
                  optimize: []
                });
              self.$mdDialog.hide(suggestionsDecisions)
            }
          }
        }
      }
    })
  }

  openJobAssignWarnings(warnings: {message: string; data?: any}[], event) {
    const self = this;
    this.$mdDialog.cancel();

    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/planning-job-assign-warnings.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {
        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = self.$mdDialog.hide;
        $scope.warnings = warnings;
      }
    });
  }

  getJobsCapacityWarnings(jobs: any[], holder: any): { message: string; data?: any }[] {
    const isTotalWeight = this.splitService.getPackageWeightIsTotal();
    const isTotalVolume = this.splitService.getPackageVolumeIsTotal();
    const warnings: { message: string; data?: any }[] = [];
    const isRoute: boolean = holder.activities || holder.resourceId;
    const resource = holder.resource ? holder.resource : holder;
    const currentTotals: { volume: number; weight: number; pallets: number } = isRoute ? {
      volume: holder.totals.totalVolume,
      weight: holder.totals.totalLoad,
      pallets: holder.totals.totalPallets
    } : {  volume: 0, weight: 0, pallets: 0 }
    const newTotals: { volume: number; weight: number; pallets: number } = jobs.reduce((acc, job) => {
      job.packages?.forEach(pkg => {
        acc.pallets += pkg.pallets || 0;
        acc.volume += (pkg.volume ? pkg.volume : pkg.dimensions?.cube) || 0;
        acc.weight += pkg.weight || 0;

        if (!isTotalWeight) {
          acc.weight *= pkg.count;
        }

        if (!isTotalVolume) {
          acc.volume *= pkg.count;
        }
      });
      return acc;
    }, { volume: 0, weight: 0, pallets: 0 });
    const capacityVolume = resource.capacity.dimensions?.cube || (resource.capacity.dimensions?.height * resource.capacity.dimensions?.width * resource.capacity.dimensions?.length);

    if (currentTotals.volume + newTotals.volume > capacityVolume) {
      const unit = this.$translate.instant(this.splitService.getVolumeUnit());
      const data = `${currentTotals.volume + newTotals.volume} / ${capacityVolume} ${unit}`;

      warnings.push({ message: 'PLANNING_JOBS_WARNINGS.INSUFFICIENT_VOLUME', data: { x: data } });
    }

    if (resource.capacity.weight && currentTotals.weight + newTotals.weight > resource.capacity.weight) {
      const unit = this.$translate.instant(this.splitService.getShortWeightUnit());
      const data = `${_.round(currentTotals.weight + newTotals.weight, 2)} / ${_.round(resource.capacity.weight, 2)} ${unit}`;

      warnings.push({ message: 'PLANNING_JOBS_WARNINGS.OVER_WEIGHT', data: { x: data } });
    }

    if (resource.capacity.numberOfPallets && currentTotals.pallets + newTotals.pallets > resource.capacity.numberOfPallets) {
      const unit = this.$translate.instant('Pallets');
      const data = `${_.round(currentTotals.pallets + newTotals.pallets, 2)} / ${_.round(resource.capacity.numberOfPallets, 2)} ${unit}`;

      warnings.push({ message: 'PLANNING_JOBS_WARNINGS.OVER_PALLETS_CAPACITY', data: { x: data } });
    }

    return warnings;
  }

  getJobsSkillMismatchWarnings(jobs: any[], resource?: any): { message: string; type?: string; data?: any }[] {
    const resourceSkills = _.get(resource, 'allocationSkills', []);

    if (!resourceSkills.length) {
      return [];
    }

    const jobSkills = _.chain(jobs)
      .flatMap((job) => _.get(job, 'skills', (job.jobType === 'Operation' ? ['Merchandise'] : ['Delivery'])))
      .uniq()
      .value();
    const missingSkills = _.difference(jobSkills, resourceSkills);

    if (!missingSkills.length) {
      return [];
    }

    return [{ message: 'PLANNING_JOBS_WARNINGS.SKILL_MISMATCH', type: 'skillMismatch', data: { missingSkills } }];
  }
}

angular
  .module('bringoz.admin.planning')
  .service('planningDialogService', PlanningDialogService);
